import { useEffect, useState } from "react";
import Styles from "./InstallPWAPrompt.module.css";
import { isPWA, isMobileView } from "../../Utility/Utility";

const DISMISS_KEY = "pwaInstallDismissedAt";
const DISMISS_DAYS = 7;

function isIos() {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
}

function wasRecentlyDismissed() {
  const dismissedAt = localStorage.getItem(DISMISS_KEY);
  if (!dismissedAt) return false;
  const daysSince =
    (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
  return daysSince < DISMISS_DAYS;
}

export default function InstallPWAPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [showIosBanner, setShowIosBanner] = useState(false);

  useEffect(() => {
    if (isPWA() || !isMobileView || wasRecentlyDismissed()) {
      return;
    }

    if (isIos()) {
      setShowIosBanner(true);
      return;
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setShowBanner(false);
    setShowIosBanner(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowBanner(false);
  };

  if (!showBanner && !showIosBanner) return null;

  return (
    <div className={Styles.installBanner}>
      <div className={Styles.installContent}>
        <img
          className={Styles.installIcon}
          src="/logo192.png"
          alt="App icon"
        />
        <div className={Styles.installTextContainer}>
          <p className={Styles.installTitle}>Install KSTORe App</p>
          {showIosBanner ? (
            <p className={Styles.installText}>
              Tap <strong>Share</strong> then{" "}
              <strong>Add to Home Screen</strong>
            </p>
          ) : (
            <p className={Styles.installText}>
              Add to your home screen for quick access
            </p>
          )}
        </div>
      </div>
      <div className={Styles.installActions}>
        {showBanner && (
          <button className={Styles.installBtn} onClick={handleInstall}>
            Install
          </button>
        )}
        <button
          className={Styles.closeBtn}
          onClick={handleDismiss}
          aria-label="Close"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
